import React, { useId, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import "./TextField.css";
import "./PasswordField.css";

const PasswordField = React.forwardRef(function PasswordField(
    {
        label,
        value,
        onChange,
        placeholder,
        hint,
        error,
        required,
        autoComplete = "current-password",
        disabled,
        ...rest
    },
    ref
) {
    const id = useId();
    const [reveal, setReveal] = useState(false);
    const handle = (e) => onChange?.(e.target.value);
    const describedBy = error ? `${id}-err` : hint ? `${id}-hint` : undefined;

    return (
        <div className={`tfield pwd-field ${error ? "tfield--invalid" : ""}`}>
            <label className="tfield__label uppercase-label" htmlFor={id}>
                {label}
                {required && <span className="tfield__req" aria-hidden="true">*</span>}
            </label>
            <div className="pwd-field__group">
                <input
                    ref={ref}
                    id={id}
                    type={reveal ? "text" : "password"}
                    value={value ?? ""}
                    onChange={handle}
                    placeholder={placeholder}
                    disabled={disabled}
                    autoComplete={autoComplete}
                    aria-invalid={error ? "true" : undefined}
                    aria-describedby={describedBy}
                    className="tfield__input pwd-field__input focus-ring"
                    {...rest}
                />
                <button
                    type="button"
                    className="pwd-field__toggle focus-ring"
                    onClick={() => setReveal((r) => !r)}
                    aria-label={reveal ? "Hide password" : "Show password"}
                    title={reveal ? "Hide password" : "Show password"}
                    tabIndex={-1}
                >
                    {reveal ? (
                        <EyeOff size={14} aria-hidden="true" />
                    ) : (
                        <Eye size={14} aria-hidden="true" />
                    )}
                </button>
            </div>
            {error ? (
                <span className="tfield__error" id={`${id}-err`} role="alert">
                    {error}
                </span>
            ) : hint ? (
                <span className="tfield__hint" id={`${id}-hint`}>
                    {hint}
                </span>
            ) : null}
        </div>
    );
});

export default PasswordField;
